import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { InterestedStudiesForm } from "components/InterestedStudiesForm";

import "./style.scss";

export const InterestedStudies = ({ labels }) => {

  return (
    <Container className="interested-studies">
      <fieldset>
      <Row>
        <Col sm={12} md={4} className="title">
          <legend className="title-interested" >{labels.title}</legend>
        </Col>
        <Col sm={12} md={6}>
          <Container className="form-container">
            <legend className="form-title">{labels.form_title}</legend>
            <InterestedStudiesForm values={labels}></InterestedStudiesForm>
          </Container>
        </Col>
      </Row>
      </fieldset>
    </Container>
  );
};
